<template>
<svg :width="width" :height="height" viewBox="0 0 18 17" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path xmlns="http://www.w3.org/2000/svg" d="M13 0C13.5523 0 14 0.447716 14 1V13.5C14 13.6734 14.145 13.84 14.145 13.84C14.2379 13.9627 14.3687 14 14.5 14C14.6313 14 14.7621 13.9627 14.8549 13.84C14.9478 13.7174 15 13.5511 15 13.3777V4H17C17.5523 4 18 4.44772 18 5V14C18 15.6569 16.6569 17 15 17H3C1.34315 17 0 15.6569 0 14V1.00002C0 0.447738 0.447716 0 1 0H13Z" fill="#80B7FF"/>
<path xmlns="http://www.w3.org/2000/svg" d="M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4C11 4.55228 10.5523 5 10 5H4C3.44772 5 3 4.55228 3 4Z" fill="white"/>
<path xmlns="http://www.w3.org/2000/svg" d="M3 8C3 7.44772 3.44772 7 4 7H10C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H4C3.44772 9 3 8.55228 3 8Z" fill="white"/>
<path xmlns="http://www.w3.org/2000/svg" d="M3 12C3 11.4477 3.44772 11 4 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H4C3.44772 13 3 12.5523 3 12Z" fill="white"/>
</svg>

</template>

<script>

export default {
    props: {
        width: { type: [Number, String], default: 18 },
        height: { type: [Number, String], default: 17 },
        color: { type: String, default: '#006EFF' }
    }
}
</script>
